<template>
    <div class="downloadDetailPage">
        <div class="detailCom">
            <!-- 电影简介 -->
            <plotIntroduced :info="movieData">
                <div class="detailComSlot" slot="title">
                    <div class="titleOuter">
                        <div class="titleLeft">{{movieData.title}}</div>
                        <div class="tltleRight">
                            <img v-if="movieData.playAmount>0" src="../assets/icon/comedy.png" alt="">
                            <span v-if="movieData.playAmount>0" class="number">{{movieData.playAmount}}</span>
                            <span class="score">{{movieData.score}}</span>
                        </div>
                    </div>
                    <div class="categoryOuter">
                        <span class="category">{{movieData.categoryValue}}</span>
                        <span v-if="filesLength>1" class="count">更新至第{{filesLength}}集</span>
                    </div>
                </div>
            </plotIntroduced>
        </div>
        <div class="downloadList">
            <div class="downloadListTitel">
                <div class="title">
                    <img src="../assets/icon/download.png" />
                    <b>剧集下载</b>
                </div>
                <div class="tab">
                    <span 
                        v-if="filesLength>1"
                        v-for="(item , i) in filesNum" 
                        @click="downloader.filesTabNumClick(i)" 
                        :class="{active: tabActive == i}"
                    >{{ downloader.filesTabNum(i) }}</span>
                </div>
            </div>
            <downloadCom
                v-if="downloadList"
                :download-data="downloadList"
                @triggerDownload="getCallback"
            />
        </div>
        <!-- 相关视频 -->
        <!--
            <div class="downloadAboutList">
                <imageList :info="downloadAboutList" @btnClick="btnClick" />
            </div>
        -->
    <loginToast :status="loginStatus" :isClose="changeStatus"></loginToast>
    <RegisteredToast
      :state="registeredState"
      :isClose="closeRegisterFn"
    ></RegisteredToast>
    <forgetPwd :state="fargetState" :isClose="forgetFn"></forgetPwd>
    </div>
</template>

<script>
import plotIntroduced from "@/components/gaoyinghao/plotIntroduced.vue"
import imageList from "@/components/gaoyinghao/imageList.vue"
import { getToken } from '../utils/auth.js'
import downloadCom from "@/components/zhangqi/downloadCom.vue"
import { trimValues } from '../utils/trimValues.js'
import FileDownloader from '../utils/downloader.js'
import loginToast from '@/views/Toast/loginToast.vue'
import RegisteredToast from '@/views/Toast/registeredToast'
import forgetPwd from '@/views/Toast/forgetPwd'

export default {
    components: {
        plotIntroduced,
        imageList,
        downloadCom,
        loginToast,
        RegisteredToast,
        forgetPwd
    },
    data() {
        return {
            loginStatus: false,
            registeredState: false,
            fargetState: false,
            downloader: new FileDownloader(this),
            movieId: this.$route.query.contentId || 34,
            videoInfo: null,
            movieData: {},
            filesLength: 0, // 一共有多少集视频
            filesNum: 0, // 可以显示多少页视频
            filesSpace: 30, // 每次显示多少集视频
            tabActive : 0,
            downloadList: null,
            downloadListArr: null,
            /*
            recomList: {
                type: "free",
                title: "相关视频",
                icon: require("../assets/icon/boutique.png"),
                list: []
            },
            */
            pageNum: 0, // 第几页
            totalPages: 0, // 一共有几页
        }
    },
    mounted() {
        this.detailData()
    },
    methods: {
        // 获取电影简介，剧集下载数据，
        // 给相关视频传参数
        detailData() {
            var that = this
            this.$axios({
                url: "/realNet/video/getVideoInfos",
                params: {
                    id: this.movieId,
                    containVideoFile: true
                },
                headers: {
                    token: getToken()
                },
                method: "get"
            }).then(res => {
                if (res.data.code == 200) {
                    that.videoInfo = res.data.result.content[0]
                }
                if (that.videoInfo) {
                    console.log(that.videoInfo)
                    // 设置keywords
                    let keywordsMeta = document.getElementsByTagName('meta')['keywords']
                    keywordsMeta.content = `${that.videoInfo.videoName}, rmhd下载, ${that.videoInfo.categoryValue}, 瑞网娱乐`
                    trimValues(that.videoInfo)
                    // 电影简介
                    that.movieData = {
                        isShow: true,
                        isNotTitle: true,
                        title: that.videoInfo.videoName,
                        cover: that.videoInfo.verticalImage,
                        score: that.videoInfo.score,
                        playAmount: that.videoInfo.playAmount,
                        categoryValue: that.videoInfo.categoryValue,
                        list: {
                            地区: [{
                                name: that.videoInfo.videoLocalityValue
                            }],
                            导演: [{
                                name: that.videoInfo.director
                            }],
                            类型: [{
                                name: that.videoInfo.videoTypeValue
                            }],
                            语言: [{
                                name: that.videoInfo.languageValue
                            }],
                            年份: [{
                                name: that.videoInfo.year
                            }],
                            简介: [{
                                name: that.videoInfo.description
                            }]
                        }
                    }
                    // 剧集下载
                    that.downloadListArr = []
                    that.videoInfo.files.map(item => {
                        if (item.fileRmhd) {
                            that.downloadListArr.push({
                                id: item.id,
                                image: item.image,
                                fmt: "rmhd",
                                file: item.fileRmhd,
                                episode: (that.videoInfo.files.length > 1)
                                  ? '第' + item.episode + '集'
                                  : '',
                                description: item.description,
                                grade: item.score,
                                duration: item.duration,
                                downloading: false
                            })
                        }
                    })
                    that.downloadList = that.downloadListArr.slice(
                        0, that.filesSpace
                    )
                    // 一个有多少集视频
                    that.filesLength = that.videoInfo.files.length
                    // 可以显示多少页视频
                    that.filesNum = Math.ceil(
                        that.filesLength / that.filesSpace
                    )
                    // 相关视频
                    //that.getRecommends()

                    that.downloader.regDownloadHandler()

                    if (document.documentElement.scrollTop)
                        document.documentElement.scrollTop = 0
                    if (document.body.scrollTop)
                        document.body.scrollTop = 0
                    if (window.pageYOffset)
                        window.pageYOffset = 0
                }
            }).catch(function(error) {
                console.log(error)
            })
        },
        // 获取相关视频数据
        /*
        getRecommends() {
          var that = this
          this.$axios({
            method: 'get',
            url: '/realNet/video/getVideoInfos',
            headers: {
              token: getToken()
            },
            params: {
              categoryId: this.videoInfo.categoryId,
              videoType: parseInt(this.videoInfo.videoType),
              videoLocality: this.videoInfo.videoLocality,
              pageSize: 4,
              orderByField: 'score',
              orderByType: 'DESC'
            }
          }).then(function(res) {
            var list = []
            res.data.result.content.map(function(item) {
              list.push({
                id: item.id,
                img: item.horizontalImage,
                imgStyle: {
                  height: (
                    document.body.clientWidth * 0.47 * 9 / 16
                  ).toFixed(1) + 'px'
                },
                name: item.videoName,
                total: item.files
                  ? '更新至' + item.files.length + '集'
                  : item.duration
              })
            })
            that.recomList = {
              type: 'hot',
              title: '热门推荐',
              gradeStyle: { bottom: '-35px' },
              iconStyle: { display: 'none' },
              titleBtnStyle: { display: 'none' },
              totalStyle: {
                bottom: '5px',
                right: '5px',
                padding: '0px 5px'
              },
              titleStyle: {
                fontSize: '20px',
                padding: '10px 0px',
                fontWeight: '600'
              },
              list: list,
              recommendList: []
            }
          }).catch(function(e) {
            console.log(e)
          })
        },
        btnClick(data){
            if (this.pageNum >= this.totalPages)
                this.pageNum = 0
            this.getRecommends()
            this.pageNum++
        },
        */
       getCallback(item) {
            try {
                this.downloader.triggerDownload(item).then(res=> {
                    if (!res) {
                        this.$message({
                            message: '请先登陆',
                            type: 'warning',
                            duration: 1000,
                            onClose: () => {
                                this.loginStatus = true
                            }
                        })
                    }
                })
            } catch(error) {
                console.log(error)
            }

       },
        changeStatus(val) {
            this.loginStatus = false
            if (val == 1) {
                this.registeredState = true
            } else if (val == 2) {
                this.fargetState = true
            }
        },
        closeRegisterFn(val) {
            this.registeredState = false
            if (val) {
                this.loginStatus = true
            }
        },
        forgetFn() {
            this.fargetState = false
        }
    }
}
</script>

<style lang="scss">
    .downloadDetailPage {
        width: 90%;
        margin: 0 5%;
        .detailCom {
            background-color: #f9f9f9;
            .plotIntroduced {
                width: 100%;
                margin: 0 auto;
                background-color: #f9f9f9;
                .img{
                    width: 60%;
                    margin: 0 auto;
                    display: block;
                }
                .content {
                    .introduced {
                        .detailComSlot {
                            margin-bottom: 10px;
                            div {
                                float: none;
                                display: block;
                            }
                            .titleOuter {
                                margin-bottom: 20px;
                                .titleLeft {
                                    font-size: 32px;
                                    color: #22252f;
                                    display: inline-block;
                                }
                                .tltleRight {
                                    position: absolute;
                                    right: 0;
                                    display: inline-block;
                                    .number {
                                        font-size: 20px;
                                        color: #22252f;
                                    }
                                    .score {
                                        font-size: 32px;
                                        color: #ff1d18;
                                        margin-left: 28px;
                                    }
                                }
                            }
                            .categoryOuter {
                                .category {
                                    display: inline-block;
                                    font-size: 14px;
                                    color: #666;
                                    border: 1px solid #666;
                                    border-radius: 20px;
                                    padding: 4px 8px;
                                }
                                .count {
                                    font-size: 14px;
                                    color: #ec2740;
                                    margin-left: 20px;
                                }
                            }
                        }
                        &>div {
                            b {
                                color: #000;
                                font-size: 14px;
                                font-weight: normal;
                            }
                        }
                    }
                }
            }
        }
        .downloadList {
            width: 100%;
            margin: 0 auto;
            .downloadListTitel {
                .title {
                    padding: 20px 40px;
                    text-align: left;
                    box-sizing: border-box;
                    position: relative;
                    &>img {
                        width: 27px;
                        height: 27px;
                        position: absolute;
                        top: 50%;
                        left: 0px;
                        transform: translate(0, -50%);
                    }
                    &>b {
                        font-size: 24px;
                    }
                }
                .tab {
                    padding-bottom: 30px;
                    >span {
                        display: inline-block;
                        width: 70px;
                        height: 30px;
                        line-height: 30px;
                        border-radius: 20px;
                        text-align: center;
                        cursor: pointer;
                        border: 1px solid #ccc;
                        margin-right: 20px;
                        &.active {
                            color: #3bc0d0;
                            border-color: #3bc0d0;
                        }
                        &:hover {
                            color: #3bc0d0;
                            border-color: #3bc0d0;
                        }
                    }
                }
            }
            .imageList {
                width: 100%;
                .title {
                    display: none;
                }
                .content {
                    padding-top: 0;
                    margin: 0 -0.5%;
                    .movieImage {
                        width: 19%;
                        height: auto;
                        margin: 0 0.5% 35px;
                        >div {
                            height: auto;
                            .img {
                                height: auto;
                                >img {
                                    width: 100%;
                                    height: auto !important;
                                }
                            }
                        }
                    }
                    .grade {
                        display: none;
                    }
                }
            }
        }
        .downloadAboutList {
            width: 100%;
            margin: 0 auto;
            .title {
                >span {
                    display: none;
                }
                >ul>li>i>img {
                    width: 16px;
                    margin-right: 10px;
                }
            }
            .imageList {
                width: 100%;
                .content {
                    padding-top: 0;
                    margin: 0 -1%;
                    .movieImage {
                        width: 23%;
                        margin: 0 1% 35px;
                        >img {
                            width: 100%;
                            height: auto;
                        }
                    }
                }
            }
        }
    }
</style>



